module.exports = __webpack_public_path__ + "img/text.46dc9fb8.png";